import { computeTotals } from './upgradesApi.js';

// Prices of an AI-imported document → prices of the quote (without VAT, whole haléře), and the balancing of the rounding
// so the quote ends at the final price printed in the document.

const round2 = (n) => Math.round(n * 100) / 100;

// The ERP stores prices without VAT. "with" = the document's prices include VAT, so they are divided by (1 + rate).
export const netPrice = (printed, mode, vatRate) => round2(mode === 'with' ? printed / (1 + vatRate / 100) : printed);

// Net prices rounded per unit drift from the document's total (e.g. 500 km × 3.31 instead of 3.3058). When the document prints a
// final price and the drift is only rounding, the difference goes to one single-quantity line, so the total matches exactly.
// rows: { include, description, qty, unit_price, edited }; finalPrice is with VAT when mode is 'with', otherwise without VAT.
// Returns { rows, status: 'none' | 'match' | 'balanced' | 'differs', total } (total = what the quote comes to in the compared basis).
export function balanceToFinalPrice(rows, { mode, vatRate, finalPrice }) {
  const chosen = rows.filter((r) => r.include && r.description.trim());
  const totalsOf = (list) => computeTotals(list.map((r) => ({ qty: Number(r.qty) || 0, unit_price: Number(r.unit_price) || 0 })), 0, vatRate);
  const compared = (totals) => (mode === 'with' ? totals.gross : totals.net);
  const current = totalsOf(chosen);
  if (!finalPrice || chosen.length === 0) return { rows, status: 'none', total: compared(current) };
  if (Math.round(compared(current) * 100) === Math.round(finalPrice * 100)) return { rows, status: 'match', total: compared(current) };

  const targetNet = mode === 'with' ? finalPrice / (1 + vatRate / 100) : finalPrice;
  const baseDeltaC = Math.round(targetNet * 100) - Math.round(current.net * 100);
  const limitC = Math.min(1000, Math.round(targetNet));
  if (Math.abs(baseDeltaC) > limitC) return { rows, status: 'differs', total: compared(current) };

  const carrier = chosen.filter((r) => Number(r.qty) === 1 && !r.edited && Number(r.unit_price) > 0).sort((a, b) => b.unit_price - a.unit_price)[0];
  if (!carrier) return { rows, status: 'differs', total: compared(current) };

  for (const nudge of [0, 1, -1, 2, -2]) {
    const price = round2(Number(carrier.unit_price) + (baseDeltaC + nudge) / 100);
    if (price < 0) continue;
    const next = rows.map((r) => (r.key === carrier.key ? { ...r, unit_price: price, balanced: true } : r));
    const totals = totalsOf(next.filter((r) => r.include && r.description.trim()));
    if (Math.round(compared(totals) * 100) === Math.round(finalPrice * 100)) return { rows: next, status: 'balanced', total: compared(totals) };
  }
  return { rows, status: 'differs', total: compared(current) };
}
